import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-77f3a641")
const _hoisted_1 = { class: "lg:container lg:mx-auto pt-8" }
const _hoisted_2 = { class: "grid lg:grid-rows-8 grid-cols-1 lg:grid-cols-3 lg:grid-flow-col gap-y-4 gap-x-0 lg:gap-x-8" }
const _hoisted_3 = { class: "col-span-2 dark:bg-gray-850 height-80" }
const _hoisted_4 = {
  key: 1,
  class: "px-4 lg:px-0 flex flex-col padding-20"
}
const _hoisted_5 = { class: "flex flex-wrap items-center -mt-2 height-80" }
const _hoisted_6 = { class: "font-ops pool-title" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 flex items-center px-2 h-10 bg-gray-50 dark:bg-gray-850" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "token-symbol" }, " FLAKE ")
], -1)
const _hoisted_8 = { class: "col-span-2 row-span-4 order-2 lg:order-1" }
const _hoisted_9 = { class: "grid grid-cols-1 gap-y-2" }
const _hoisted_10 = { class: "mb-2 px-1 lg:p-4 bg-gray-850" }
const _hoisted_11 = { class: "mb-4 px-1 lg:p-4 bg-gray-850" }
const _hoisted_12 = { class: "row-span-6 order-1 lg:order-2 px-1 lg:px-0" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_BalAsset = _resolveComponent("BalAsset")!
  const _component_FlakeStatCards = _resolveComponent("FlakeStatCards")!
  const _component_FlakeTransactionsCard = _resolveComponent("FlakeTransactionsCard")!
  const _component_FlakeAction = _resolveComponent("FlakeAction")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loadingPool)
          ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
              key: 0,
              class: "h-16 height-80"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h3", _hoisted_6, [
                  _createVNode(_component_BalAsset, {
                    class: "mr-9",
                    size: 32,
                    width: 70,
                    iconURI: require('@/assets/images/Flake.svg')
                  }, null, 8, ["iconURI"])
                ]),
                _hoisted_7
              ])
            ]))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_FlakeStatCards, {
              loading: _ctx.loadingPool,
              baseFlakeInfos: _ctx.baseFlakeInfos
            }, null, 8, ["loading", "baseFlakeInfos"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_FlakeStatCards, {
              userInfos: _ctx.userInfos,
              loading: _ctx.loadingPool,
              baseFlakeInfos: _ctx.baseFlakeInfos,
              personal: true
            }, null, 8, ["userInfos", "loading", "baseFlakeInfos"])
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_FlakeTransactionsCard, {
            baseFlakeInfos: _ctx.baseFlakeInfos,
            loading: _ctx.loadingPool,
            userLeaveRequestsQuery: _ctx.userLeaveRequestsQuery
          }, null, 8, ["baseFlakeInfos", "loading", "userLeaveRequestsQuery"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_ctx.loadingPool)
          ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
              key: 0,
              class: "pool-actions-card h-60 mb-4"
            }))
          : true
            ? (_openBlock(), _createBlock(_component_FlakeAction, {
                key: 1,
                changeType: "stake",
                class: "mb-5",
                userLeaveRequestsQuery: _ctx.userLeaveRequestsQuery
              }, null, 8, ["userLeaveRequestsQuery"]))
            : _createCommentVNode("", true)
      ])
    ])
  ]))
}